<template>
  <div class="lg:px-20 md:px-12 px-5 lg:py-8 md:py-6 py-4">
    <div class="flex justify-between">
      <p class="text-primary font-semibold fsize20 sm-fsize18">
        <!-- {{ getAllCategory.result[0].podcast_count }} seasons -->
      </p>
      <!-- <feather-icon
        icon="MoreHorizontalIcon"
        class="text-primary"
        svgClasses="w-5 h-5 ml-1"
      ></feather-icon> -->
    </div>
    <div v-for="item in getAllCategory.result[0].podcastId" :key="item._id">
      <hr class="mt-2" />
      <div
        @click="handleRedirect(item)"
        class="lg:flex md:flex gap-4 lg:px-8 md:px-8 px-6 lg:py-6 md:py-6 py-4 cursor-pointer"
      >
        <div class="w-60per sm-wfull lg:pb-0 md:pb-0 pb-4">
          <p class="fsize20 sm-fsize18 font-semibold clr-black">
            {{ item.name }}
          </p>
          <p class="py-2 sm-fsize14" v-html="item.description"></p>
          <p class="font-semibold fsize14 sm-fsize12">
            {{ item.episode_count }} Podcasts
          </p>
        </div>
        <div class="w-40per sm-wfull">
          <!-- <iframe class="scrnht-200 w-full" src="" frameborder="0"></iframe> -->
          <img
            v-if="item.episodes && item.episodes[0] && item.episodes[0].image"
            class="scrnht-250 w-full rounded-xl object-contain"
            :src="`${$imageURL}/${item.episodes[0].image}`"
            alt="img"
          />
          <!-- <img
            class="scrnht-250 w-full rounded-xl object-cover"
            src="https://nexuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
            alt="img"
          /> -->
        </div>
      </div>
    </div>
    <!-- <div class="lg:px-8 md:px-8 px-6 lg:py-6 md:py-6 py-4">
      <div class="grid lg:grid-cols-3 md:grid-cols-3 grid-cols-2 gap-6">
        <img
          src="https://nexuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
          alt="img"
          class="lg:h-52 md:h-52 h-40 w-full rounded-xl"
        />
        <img
          src="https://nexuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
          alt="img"
          class="lg:h-52 md:h-52 h-40 w-full rounded-xl"
        />
        <img
          src="https://nexuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
          alt="img"
          class="lg:h-52 md:h-52 h-40 w-full rounded-xl"
        />
      </div>
      <router-link :to="'/videospage'">
        <div class="flex items-center justify-end gap-2 clr-cd45af pt-4 cursor-pointer">
          <p class="font-semibold sm-fsize14">Watch More</p>

          <feather-icon
            icon="ArrowRightIcon"
            class="clr-cd45af"
            svgClasses="w-5 h-5 "
          ></feather-icon>
        </div>
      </router-link>
    </div> -->
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("podcast", { getAllCategory: "getAllCategory" }),
  },
  methods: {
    async handleFrame(url) {
      // console.log(url, "url data")
      const spotifyRegex =
        /(?:https?:\/\/)?(?:open\.spotify\.com\/|spotify:)([^\s]+)/;
      const match = url.match(spotifyRegex);

      if (match) {
        const embedUrl = `https://open.spotify.com/oembed?url=${encodeURIComponent(
          url
        )}`;
        // console.log(embedUrl, "embedUrl data")
        try {
          const response = await fetch(url);
          console.log(response, "response data");
          const data = await response.json();
          return data.thumbnail_url;
        } catch (error) {
          console.error("Failed to fetch Spotify oEmbed data:", error);
          return "";
        }
      }
    },
    handleRedirect(item) {
      if (item.episode_count == 0) {
        this.$notify.error({
          message: "There are no podcasts available",
          position: "top-right",
        });
      } else {
        this.$router.push({
          name: "podcast-episodepage",
          query: {
            podcastId: item._id,
          },
        });
      }
    },
  },
  async mounted() {
    try {
      // let data = await this.$store.dispatch("podcast/getall_category", {
      //   cid: this.$route.query.cid,
      // });
    } catch (error) {}
    // console.log("getAllCategory", this.getAllCategory);
  },
};
</script>
